const parsePaymentValue = (value: number) => {
  if (value?.toFixed) {
    return value.toFixed(2);
  }

  return value;
};

export default parsePaymentValue;
